import { render, staticRenderFns } from "./LegacyMenuCollapseItemContent.vue?vue&type=template&id=95b68206&"
import script from "./LegacyMenuCollapseItemContent.vue?vue&type=script&lang=js&"
export * from "./LegacyMenuCollapseItemContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports